import { default as api } from 'config/authApiConf.js';

export const listContactService = async (page = 1) => {
	try {
		let result = await api.get(`/cms/list-contact?page=${page}`);
		return result;
	} catch (error) {
		return error;
	}
};
